import React from "react";
import { ProductionPlanningFields } from "./EtiquetageFields";

export default function RobotFields(props) {
    return <ProductionPlanningFields {...props} showRobotComment />;
}
